import { toast } from "react-toastify";

import axiosInstance from "../functions/axiosInstance";
import { CookieType } from "./Types";

export const getUrlPrefixForPreviews = (paramsObject: any) => {
    let prefix = "";

    if (paramsObject?.props?.templatePreview) {
        prefix = `/${paramsObject?.props?.params?.platform}/${paramsObject?.props?.params?.templateVersionId}`
    } else if (paramsObject?.props?.builderPreview) {
        prefix = `/preview/${paramsObject?.props?.params?.projectId}/${paramsObject?.props?.params?.platform}`
    }

    return prefix;
}

export const verifyOTP = async (
    paramsObject: any,
    {
        api,
        defaultNavigateTo,
        cookieType,
        loginUser,
    }: {
        api: string;
        defaultNavigateTo: string;
        cookieType: CookieType,
        loginUser: boolean;
    }
) => {
    if (paramsObject?.props?.componentsPreview || paramsObject?.props?.builder) {
        return;
    }

    if (paramsObject.props.templatePreview || paramsObject?.props?.builderPreview) {
        paramsObject?.props?.contextVariables?.setUser?.({
            first_name: "Dummy",
            last_name: "User",
            email: "dummyuser@gmail.com",
            phone_number: "919876543210",
            username: "dummyuser123",
            unique_id: paramsObject?.props?.builderPreview
                ? paramsObject?.props?.params?.projectId
                : sessionStorage.getItem("recordsIdentifier"),
        });

        toast.success("OTP verified successfully");

        const prefix = getUrlPrefixForPreviews(paramsObject);

        paramsObject.props.navigate(`${prefix}${paramsObject.data.navigateTo || defaultNavigateTo}`);

        return;
    }

    try {
        paramsObject.setSubmitting(true);
        paramsObject.props.contextVariables.setIsAnimating(true);

        const key = sessionStorage.getItem("key");
        if (!key) throw new Error("Something went wrong!");

        let data = {
            ...paramsObject.values,
        };

        const isEmail = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(key);

        data[isEmail ? "email" : "phone_number"] = key;

        if (paramsObject.data.verify) {
            data = {
                ...data,
                ...paramsObject.data.verify,
            };
        }

        const response = await axiosInstance(paramsObject).post(
            api,
            data,
            {
                withCredentials: true,
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
            }
        );
        // console.log('response', response);

        // set cookie
        setCookie(response.data.data.token, cookieType);

        // don't set user yet
        if (loginUser) {
            paramsObject.props.contextVariables.setUser(response.data.data.user);
        }

        sessionStorage.removeItem("key");

        toast.success(response.data.message);

        paramsObject.props.navigate(paramsObject.data.navigateTo || defaultNavigateTo);
    } finally {
        paramsObject.setSubmitting(false);
        paramsObject.props.contextVariables.setIsAnimating(false);
    }
}

export const resendOTP = async (
    paramsObject: any,
    {
        api,
        previewMessage,
        otpType,
    }: {
        api: string;
        previewMessage: string;
        otpType: "forgot_password" | "verify_registration";
    }
) => {

    // Template / Builder / Component Preview
    if (paramsObject.props.templatePreview || paramsObject.props.builderPreview || paramsObject?.props?.componentsPreview) {
        if (paramsObject?.props?.componentsPreview) {
            paramsObject?.e?.stopPropagation();
        }

        paramsObject.props.setSingleData(paramsObject.data.countdownValue || 45);

        if (!paramsObject?.props?.componentsPreview) {
            toast.success(previewMessage);
        }

        return;
    }

    try {
        paramsObject.props.contextVariables.setIsAnimating(true);

        const key = sessionStorage.getItem("key");
        if (!key) throw new Error("Something went wrong!");

        const isEmail = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(key);

        let data: any = {
            [isEmail ? "email" : "phone_number"]: key,
        };

        if (paramsObject.data.verify) {
            data = {
                ...data,
                ...paramsObject.data.verify,
            };
        }

        const response = await axiosInstance(paramsObject).post(api, { ...data, otpType });

        paramsObject.props.setSingleData(paramsObject.data.countdownValue || 45);

        toast.success(response.data.message);
    } finally {
        paramsObject.props.contextVariables.setIsAnimating(false);
    }
}

// set cookie by calling next.js API route
export const setCookie = async (token: string, cookieType: CookieType) => {
    await fetch("/api/cookie/set-cookie", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            token,
            cookieType
        }),
    });
}

// delete cookie by calling next.js API route
export const deleteCookie = async (cookieType: CookieType) => {
    await fetch("/api/cookie/delete-cookie", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            cookieType
        })
    });
};
